import { render, staticRenderFns } from "./Transferencias.vue?vue&type=template&id=23c6b496"
import script from "./Transferencias.vue?vue&type=script&lang=ts"
export * from "./Transferencias.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports